import { ETLCourse } from './types';
import { DBT_COURSE } from './dbt-course';
import { SSIS_AZURE_COURSE } from './ssis-course';
import { INFORMATICA_COURSE } from './informatica-course';
import { AWS_GLUE_COURSE, MODERN_ELT_COURSE } from './modern-elt-course';
import { 
  STREAMING_ETL_COURSE, 
  DATA_QUALITY_COURSE, 
  PERFORMANCE_OPTIMIZATION_COURSE, 
  ENTERPRISE_ARCHITECTURE_COURSE 
} from './advanced-specializations';
import { 
  CAPSTONE_PROJECT_COURSE, 
  CAREER_DEVELOPMENT_COURSE, 
  CERTIFICATION_PREP_COURSE 
} from './capstone-courses';

export const ETL_COURSES: ETLCourse[] = [
  // Phase 1: Core Tools
  DBT_COURSE,
  SSIS_AZURE_COURSE,
  INFORMATICA_COURSE,
  // Phase 2: Cloud & Modern ELT
  AWS_GLUE_COURSE,
  MODERN_ELT_COURSE,
  // Phase 3: Advanced Specializations
  STREAMING_ETL_COURSE,
  DATA_QUALITY_COURSE,
  PERFORMANCE_OPTIMIZATION_COURSE,
  ENTERPRISE_ARCHITECTURE_COURSE,
  // Phase 4: Integration & Capstone
  CAPSTONE_PROJECT_COURSE,
  CAREER_DEVELOPMENT_COURSE,
  CERTIFICATION_PREP_COURSE
];

// Export individual courses for direct access
export { 
  DBT_COURSE,
  SSIS_AZURE_COURSE,
  INFORMATICA_COURSE,
  AWS_GLUE_COURSE,
  MODERN_ELT_COURSE,
  STREAMING_ETL_COURSE,
  DATA_QUALITY_COURSE,
  PERFORMANCE_OPTIMIZATION_COURSE,
  ENTERPRISE_ARCHITECTURE_COURSE,
  CAPSTONE_PROJECT_COURSE,
  CAREER_DEVELOPMENT_COURSE,
  CERTIFICATION_PREP_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const ETL_COURSE_METADATA = {
  totalCourses: ETL_COURSES.length,
  totalDuration: '130-170 hours',
  tools: ['dbt', 'Microsoft Stack', 'Informatica', 'AWS Glue', 'Google Dataflow', 'Modern ELT', 'Kafka', 'Spark', 'Flink', 'Data Quality'],
  marketDemand: 'high',
  salaryRange: '$85,000 - $220,000',
  careerPath: [
    'Junior ETL Developer',
    'ETL Developer', 
    'Senior ETL Developer',
    'ETL Architect',
    'Data Engineering Manager'
  ],
  keySkills: [
    'SQL & Database Design',
    'Data Transformation Logic',
    'ETL Tool Expertise (dbt, SSIS, Informatica)',
    'Cloud Platform Integration',
    'Performance Optimization',
    'Data Quality & Testing',
    'Production Deployment',
    'Monitoring & Troubleshooting',
    'Version Control & CI/CD',
    'Business Process Understanding'
  ],
  industryApplications: [
    'Financial Services - Regulatory Reporting',
    'Healthcare - Patient Data Integration', 
    'Retail - Customer 360 Views',
    'Manufacturing - Supply Chain Analytics',
    'Telecommunications - Customer Data Platforms',
    'Insurance - Claims Processing',
    'Government - Citizen Services Data',
    'Energy - Smart Grid Analytics'
  ],
  certificationPrep: [
    'dbt Analytics Engineering Certification',
    'Microsoft Azure Data Engineer Associate',
    'Informatica PowerCenter Certification',
    'AWS Certified Data Engineer',
    'Google Cloud Data Engineer'
  ]
};